import { useState, useEffect } from "react";
import { UserGroupIcon, CursorArrowRippleIcon, ArrowLeftStartOnRectangleIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import SkeletonCard from "../../Skeleton/SkeletonCard";
import cdpService from "../../../apiService/cdp.service";

const StatsCard = ({ name, stat, icon: Icon, bg, iconcolor }) => (
    <div className="relative px-6 lg:px-6 py-6">
        <div className="flex items-center">
            <div className="mr-4">
                <div className={`rounded-full p-5 ${bg}`}>
                    <Icon aria-hidden="true" className={`w-8 h-8 ${iconcolor}`} />
                </div>
            </div>
            <dd>
                <p className="truncate text-sm font-medium text-gray-500 flex">
                    {name} <InformationCircleIcon aria-hidden="true" className="size-5 ms-1" />
                </p>
                <p className="text-3xl font-bold text-gray-900">{stat}</p>
            </dd>
        </div>
    </div>
);

const FilteredStats = ({ filters = {} }) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            if(error?.length){
                setError(null);
            }
            try {
                const response = await cdpService.getFilteredDemographicCount(filters);
                const data = response.data;
                if (data.success) {
                    setStats(data.data.filteredSignupCounts);
                } else {
                    throw new Error("Failed to fetch data");
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [filters]);

    if (loading) return <SkeletonCard length={3} />;
    if (error) return <p>Error loading stats: {error}</p>;

    const filterstats = [
        { id: 1, name: "Total Registered Users", stat: stats.totalSignups.toLocaleString(), icon: UserGroupIcon, bg: "bg-red-100", iconcolor: "text-red-500" },
        { id: 2, name: "Current Month Sign-ups", stat: stats.currentMonthSignups.toLocaleString(), icon: CursorArrowRippleIcon, bg: "bg-green-100", iconcolor: "text-green-500" },
        { id: 3, name: "Today's Sign-Ups", stat: stats.todaySignups.toLocaleString(), icon: ArrowLeftStartOnRectangleIcon, bg: "bg-purple-100", iconcolor: "text-purple-500" },
    
    ];

    return (
        <>
          
                {filterstats.map((item) => (
                    <StatsCard key={item.id} {...item} />
                ))}
            
            
        </>
    );
};

export default FilteredStats;
